import React   from "react";
import { Link, useHistory } from "react-router-dom";

import ROUTES from "../../../utils/routes";

import { useSelector,useDispatch }              from "react-redux";
import { 
    setCadenaBusquedaAction,
    setResultsPageAction
}                                               from "../../../actions/searchActions";


import { 
    encodeNumber as nToString
}   from "../../../API/request";
import InSearch from "../../InSearch";

const OverlayMobile = ( {headerExtended}) => {
    const dispatch = useDispatch();
    let history = useHistory()

    const [showMenu, setShowMenu] = React.useState(false);
    const [showBusqueda, setShowBusqueda] = React.useState(false);

    let busquedaObj = useSelector((state) => state.search);

    const closeOverlay = () => {
        dispatch(setCadenaBusquedaAction("",busquedaObj.articulos));
    }
    const copyFilterResults = () => {
        dispatch(setResultsPageAction(busquedaObj.filtroArticulos));
    }
    const handleClick = () => {
        copyFilterResults();
        closeOverlay();
        history.push( ROUTES.SEARCHRESULTS);
    }
    const abrirMenu = () => {
        setShowMenu(true);
    }
    const cerrarMenu = () => {
        setShowMenu(false);
    }
    const abrirBusqueda = () => {
        setShowBusqueda(true);
    }
    const cerrarBusqueda = () => {
        setShowBusqueda(false);
    }
    const goBack = () => {
        history.goBack()
    }

    const cerrarTodo = ()  => {
        closeOverlay();
        cerrarMenu();
    }

    return (
        <>
            <div className={ headerExtended ? "home-nav-mobile mt-0" : "home-nav-mobile"}>
                <div className="container collectionDetails_mobile--navigation">
                    <div className="row">
                        <div className="col-10">
                            {
                                headerExtended &&
                                    <button className="btn-general btn-tertiary-prev black v-align-c" onClick={goBack}>
                                        <svg className="i-rotate" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                                        <path id="arrow_right" d="M10.735,16.028,12,17.293l6-6-6-6L10.735,6.558l3.84,3.84H6v1.789h8.576Z" transform="translate(-6 -5.293)" fill="#fff"/>
                                        </svg>
                                        <span>Volver</span>
                                    </button>
                            }
                        </div>
                        <div className="col-2 collectionDetails_mobile--navigation--menu">
                            <div className="dropdown">
                                <button className="" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" data-bs-display="static" aria-expanded="false" onClick={(e) => abrirMenu()}>
                                    <svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M0 4h24v3H0zM0 11h18v3H0zM0 18h12v3H0z"></path></svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>                      
            </div>
            <div className={ !showMenu ? "preResultsNav-Mobile" : "preResultsNav-Mobile active" }>
                {
                    !showBusqueda
                    ?   <div className="preResultsNav-Mobile-category pt-2">
                            <div className="container">
                                <div className="row">
                                    <div className="col-2">
                                        <button onClick={(e) => abrirBusqueda()}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20.001" viewBox="0 0 20 20.001"><path id="bx-search" d="M10.553,19.106a8.5,8.5,0,0,0,5.235-1.8l4.7,4.7L22,20.489l-4.7-4.7a8.543,8.543,0,1,0-6.747,3.316Zm0-14.968a6.415,6.415,0,1,1-6.415,6.415A6.421,6.421,0,0,1,10.553,4.138Z" transform="translate(-2 -2)" fill="#000000"></path></svg>
                                        </button>
                                    </div>
                                    <div className="col-2 offset-8 ta-e">
                                        <button onClick={(e) => cerrarMenu()}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 13.975 13.973"><path id="x" d="M18.521,6.344l-5.241,5.24L8.04,6.344,6.293,8.091l5.24,5.24-5.24,5.24L8.04,20.317l5.24-5.24,5.241,5.24,1.747-1.747-5.24-5.24,5.24-5.24Z" transform="translate(-6.293 -6.344)" fill="#000000"></path></svg>
                                        </button>
                                    </div>
                                </div>
                                <div className="row mt-4 pb-4">
                                    <div className="col-12">
                                        {
                                            busquedaObj.categorias.map( (item,i) => 
                                                <Link className="d-block" key={ "liClist_sub_" + i } to={ROUTES.COLLECTIONSEMPTY + nToString(item.idCategoria)} onClick={(e) => cerrarMenu()}>{item.nombre}</Link>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    : <div className="preResultsNav-Mobile-busqueda pt-2">
                        <div className="container">
                            <div className="row">
                                <div className="col-2">
                                    
                                    <InSearch isMobile={true} />
                                </div>
                                <div className="col-2 offset-8 ta-e">
                                    <button onClick={(e) => cerrarBusqueda()}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 13.975 13.973"><path id="x" d="M18.521,6.344l-5.241,5.24L8.04,6.344,6.293,8.091l5.24,5.24-5.24,5.24L8.04,20.317l5.24-5.24,5.241,5.24,1.747-1.747-5.24-5.24,5.24-5.24Z" transform="translate(-6.293 -6.344)" fill="#000000"></path></svg>
                                    </button>
                                </div>
                            </div>
                            <div className="row mt-4 pb-4">
                                <div className="col-12">
                                    <div className="preResultsNav-Mobile-find">
                                        <div className="preResultsNav-Mobile-find-elements">
                                            <div className="preResultsNav-Mobile-find-elements-resulst">
                                                {
                                                    busquedaObj.filtroArticulos.length < 6 &&
                                                        busquedaObj.filtroArticulos.map( (articuloItem, i) => 
                                                            <Link 
                                                                to={ROUTES.DETAILSEMPTY + nToString(articuloItem.id)}
                                                                onClick={(e) => closeOverlay()}
                                                                key={"articleFilter-"+i}
                                                                >{articuloItem.nombre}
                                                            </Link>
                                                        )
                                                }
                                                {
                                                    busquedaObj.filtroArticulos.length > 5 && 
                                                        <>
                                                            <Link to={ROUTES.DETAILSEMPTY + nToString(busquedaObj.filtroArticulos[0].id)} onClick={(e) => closeOverlay()}>{busquedaObj.filtroArticulos[0].nombre}</Link>
                                                            <Link to={ROUTES.DETAILSEMPTY + nToString(busquedaObj.filtroArticulos[1].id)} onClick={(e) => closeOverlay()}>{busquedaObj.filtroArticulos[1].nombre}</Link>
                                                            <Link to={ROUTES.DETAILSEMPTY + nToString(busquedaObj.filtroArticulos[2].id)} onClick={(e) => closeOverlay()}>{busquedaObj.filtroArticulos[2].nombre}</Link>
                                                            <Link to={ROUTES.DETAILSEMPTY + nToString(busquedaObj.filtroArticulos[3].id)} onClick={(e) => closeOverlay()}>{busquedaObj.filtroArticulos[3].nombre}</Link>
                                                            <Link to={ROUTES.DETAILSEMPTY + nToString(busquedaObj.filtroArticulos[4].id)} onClick={(e) => closeOverlay()}>{busquedaObj.filtroArticulos[4].nombre}</Link>
                                                        </>
                                                }
                                                {
                                                    busquedaObj.filtroArticulos.length === 0 && 
                                                        <>
                                                            <span>No se encontraron resultados</span>
                                                        </>
                                                }
                                            </div>

                                            {
                                                busquedaObj.filtroArticulos.length > 1 &&
                                                    <button onClick={handleClick}>
                                                        Mostrar todos los resultados
                                                        <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M10 16.9L15.5 11.5 10 6.1" fill="none" stroke="currentColor"></path>
                                                        </svg>
                                                    </button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                
                {
                    showMenu &&
                        <div className="preResultsNav-Mobile-overlay" onClick={(e) => cerrarTodo()}></div>
                }
            </div>
        </>
    );
};

export default OverlayMobile;
